import { registerBlock } from '../../core/registry.js';
import { GroupCanvas, GroupInspector } from './Canvas.jsx';

const definition = {
  type: 'group',
  schema: {
    defaults: () => ({ background: '', padding: 16, borderRadius: 0 }),
  },
  capabilities: {
    isContainer: true,
    allowedChildren: null, // accepts any block except columns-only 'column'
  },
  ui: {
    Canvas: GroupCanvas,
    Inspector: GroupInspector,
    icon: '📦',
    label: 'Group',
    keywords: ['container', 'box', 'section', 'wrapper'],
  },
  serialize: (attrs, innerHtml) => {
    const style = [
      attrs.background ? `background:${attrs.background}` : '',
      `padding:${attrs.padding || 0}px`,
      attrs.borderRadius ? `border-radius:${attrs.borderRadius}px` : '',
    ].filter(Boolean).join(';');
    return `<div style="${style}">${innerHtml}</div>`;
  },
};

registerBlock(definition);
export default definition;
